import { useEffect, useState } from "react";
import Modal from "../../components/molecules/Modal";
import dayjs from "dayjs";

const Quotation = (props) => {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "PHP",

    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  });

  const quoteData = props.quoteData;
  //console.log("quoteData", quoteData);
  const [open, setOpen] = useState(false);
  function validateForm() {
    //validation for stepper form
    return true;
  }

  useEffect(() => {
    handleSubmit();
  }, []);

  const handleInfoDeductible = () => {
    setOpen(true);
  };

  const handleSubmit = () => {
    props.handleNextState(validateForm);
  };
  return (
    <form>
      <div>
        <div className="text-left mb-24">
          <div className="text-left mb-10">
            <div className="flex">
              <div className="flex-1 text-left">
                <span className="font-bold text-lg title-font">
                  Your Motorcar Insurance Renewal
                </span>
              </div>
              {/* 
               <div className="float-right text-right">
                <button type="button">
                  <span className="text-blue-500 font-bold text-xs">
                    Benefits
                  </span>
                </button>
              </div>  */}
            </div>

            <div className="mt-8">
              <span className="text-base font-bold text-gray-500 title-font">
                Policy Coverage
              </span>
              <div className="mt-3 bg-gray-50 pl-3 pr-3">
                <div className="flex">
                  <div className="flex-1 text-left">
                    <span className="text-left text-sm font-bold">
                      Start Date
                    </span>
                  </div>
                  <div className="flex-1 text-right">
                    <span className="text-sm">
                      {dayjs(quoteData.startDate).format("MMMM D, YYYY")}
                    </span>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 pl-3 pr-3">
                <div className="flex">
                  <div className="flex-1 text-left">
                    <span className="text-left text-sm font-bold">
                      Start End
                    </span>
                  </div>
                  <div className="flex-1 text-right">
                    <span className="text-sm">
                      {dayjs(quoteData.endDate).format("MMMM D, YYYY")}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-5">
              <span className="text-base font-bold title-font">
                {quoteData.year} {quoteData.make} {quoteData.model}
              </span>

              <div className="mt-8">
                <span className="text-base font-bold text-gray-500 title-font">
                  Annual Premium:
                </span>
                <div className="mt-3 bg-gray-50 p-3 rounded-lg">
                  <div className="flex">
                    <div className="flex-1 text-left">
                      <span className="text-left text-sm font-bold">
                        Basic Premium
                      </span>
                    </div>
                    <div className="flex-1 text-right">
                      <span className="text-sm">PHP</span>
                    </div>
                    <div className="flex-1 text-right">
                      <span className="text-sm">
                        {formatter
                          .format(quoteData.premium.premium)
                          .replace("₱", "")}
                      </span>
                    </div>
                  </div>

                  <div className="flex">
                    <div className="flex-1 text-left">
                      <span className="text-left text-sm font-bold">VAT</span>
                    </div>
                    <div className="flex-1 text-right">
                      <span className="text-sm">PHP</span>
                    </div>
                    <div className="flex-1 text-right">
                      <span className="text-sm">
                        {formatter
                          .format(quoteData.premium.evat)
                          .replace("₱", "")}
                      </span>
                    </div>
                  </div>

                  <div className="flex">
                    <div className="flex-1 text-left">
                      <span className="text-left text-sm font-bold">DST</span>
                    </div>
                    <div className="flex-1 text-right">
                      <span className="text-sm">PHP</span>
                    </div>
                    <div className="flex-1 text-right">
                      <span className="text-sm">
                        {formatter
                          .format(quoteData.premium.dst)
                          .replace("₱", "")}
                      </span>
                    </div>
                  </div>

                  <div className="flex">
                    <div className="flex-1 text-left">
                      <span className="text-left text-sm font-bold">LGT</span>
                    </div>
                    <div className="flex-1 text-right">
                      <span className="text-sm">PHP</span>
                    </div>
                    <div className="flex-1 text-right">
                      <span className="text-sm">
                        {formatter
                          .format(quoteData.premium.lgt)
                          .replace("₱", "")}
                      </span>
                    </div>
                  </div>

                  {quoteData.premium.otherAmount1 ? (
                    <div className="flex">
                      <div className="flex-1 text-left">
                        <span className="text-left text-sm font-bold">
                          Roadside Assistance Fee
                        </span>
                      </div>
                      <div className="flex-1 text-right">
                        <span className="text-sm">PHP</span>
                      </div>
                      <div className="flex-1 text-right">
                        <span className="text-sm">
                          {formatter
                            .format(quoteData.premium.otherAmount1)
                            .replace("₱", "")}
                        </span>
                      </div>
                    </div>
                  ) : null}

                  {!!quoteData?.premium?.otherAmount3 && (
                    <div className="flex">
                      <div className="flex-1 text-left">
                        <span className="text-left text-sm font-bold">
                          Others
                        </span>
                      </div>
                      <div className="flex-1 text-right">
                        <span className="text-sm">PHP</span>
                      </div>
                      <div className="flex-1 text-right">
                        <span className="text-sm">
                          {formatter
                            .format(quoteData.premium.otherAmount3)
                            .replace("₱", "")}
                        </span>
                      </div>
                    </div>
                  )}

                  <hr className="my-5" />

                  <div className="flex bg-blue-200 p-3 rounded">
                    <div className="flex-1 text-left">
                      <span className="text-left text-base font-bold">
                        Total Amount
                      </span>
                    </div>
                    <div className="flex-1 text-right">
                      <span className="text-base">PHP</span>
                    </div>
                    <div className="flex-1 text-right">
                      <span className="text-base font-bold">
                        {formatter
                          .format(quoteData.premium.total)
                          .replace("₱", "")}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-8 mb-20">
                <span className="text-base font-bold title-font">
                  Your comprehensive insurance policy includes the following
                  coverages:
                </span>
                <div className="mt-3 bg-gray-50 p-3 rounded-lg">
                  <div className="flex">
                    <div className="flex-1 text-left">
                      <span className="text-left text-xs leading-none">
                        Own Damages/Theft
                      </span>
                    </div>
                    <div className="flex-1 text-right">
                      <span className="text-xs leading-none">PHP</span>
                    </div>
                    <div className="flex-1 text-right">
                      <span className="text-xs leading-none">
                        {formatter
                          .format(quoteData.odCoverage)
                          .replace("₱", "")}
                      </span>
                    </div>
                  </div>

                  <div className="flex">
                    <div className="flex-1 text-left">
                      <span className="text-left text-xs leading-none">
                        Third Party Property Damage
                      </span>
                    </div>
                    <div className="flex-1 text-right">
                      <span className="text-xs leading-none">PHP</span>
                    </div>
                    <div className="flex-1 text-right">
                      <span className="text-xs leading-none">
                        {formatter
                          .format(quoteData.pdCoverage)
                          .replace("₱", "")}
                      </span>
                    </div>
                  </div>

                  <div className="flex">
                    <div className="flex-1 text-left">
                      <span className="text-left text-xs leading-none">
                        Third Party Bodily Injury
                      </span>
                    </div>
                    <div className="flex-1 text-right">
                      <span className="text-xs leading-none">PHP</span>
                    </div>
                    <div className="flex-1 text-right">
                      <span className="text-xs leading-none">
                        {formatter
                          .format(quoteData.pdCoverage)
                          .replace("₱", "")}
                      </span>
                    </div>
                  </div>

                  <div className="flex">
                    <div className="flex-1 text-left">
                      <span className="text-left text-xs leading-none">
                        Auto Personal Accident
                      </span>
                    </div>
                    <div className="flex-1 text-right">
                      <span className="text-xs leading-none">PHP</span>
                    </div>
                    <div className="flex-1 text-right">
                      <span className="text-xs leading-none">
                        {formatter
                          .format(quoteData.paCoverage)
                          //.format("300000")
                          .replace("₱", "")}
                      </span>
                    </div>
                  </div>

                  <div className="flex">
                    <div className="flex-1 text-left">
                      <span className="text-left text-xs leading-none">
                        Acts of Nature
                      </span>
                    </div>
                    <div className="flex-1 text-right">
                      <span className="text-xs leading-none">PHP</span>
                    </div>
                    <div className="flex-1 text-right">
                      <span className="text-xs leading-none">
                        {formatter
                          .format(quoteData.aonCoverage)
                          .replace("₱", "")}
                      </span>
                    </div>
                  </div>

                  <div className="flex">
                    <div className="flex-1 text-left">
                      <span className="text-left text-xs leading-none">
                        Emergency Road Assistance
                      </span>
                    </div>
                    <div className="flex-1 text-right">
                      <span className="text-xs leading-none"></span>
                    </div>
                   <div className="flex-1 text-right">
                      <span className="text-xs leading-none">
                        {quoteData.premium.otherAmount1 === 100
                          ? "COVERED"
                          : "FREE"}
                      </span>
                    </div>
                  </div>
                </div>
                {/* 
                <div className="bg-gray-50 flex mt-5 p-3 rounded">
                  <div className="flex-1 text-left">
                    <span className="text-right text-sm">Deductible </span>

                    <button
                      type="button"
                      onClick={handleInfoDeductible}
                      value="chassis"
                    >
                      <div className="icon-info-deductible">
                        <img
                          src={"/images/info.png"}
                          alt="info"
                          className="icon-info-image-deductible"
                        />
                      </div>
                    </button>
                  </div>
                  <div className="flex-1 text-right">
                    <span className="text-sm">PHP</span>
                  </div>
                  <div className="flex-1 text-right">
                    <span className="text-sm">
                      {formatter.format(quoteData.deductible).replace("₱", "")}
                    </span>
                  </div>
                  <span className="block text-sm leading-6 text-gray-500 mt-1">
                    * This is the amount you need to pay if you make a motor
                    claim. It’s your share of the cost while your insurance
                    takes care of the claim.
                  </span>
                </div> */}
                <div className="mt-3 bg-gray-50 p-3 rounded-lg">
                  <div className="flex">
                    <div className="flex-1 text-left">
                      <span className="text-left text-sm">Deductible </span>

                      {/* <button
                        type="button"
                        onClick={handleInfoDeductible}
                        value="chassis"
                      >
                        <div className="icon-info-deductible">
                          <img
                            src={"/images/info.png"}
                            alt="info"
                            className="icon-info-image-deductible"
                          />
                        </div>
                      </button> */}
                    </div>
                    <div className="flex-1 text-right">
                      <span className="text-sm">PHP</span>
                    </div>
                    <div className="flex-1 text-right">
                      <span className="text-sm">
                        {formatter
                          .format(quoteData.deductible)
                          .replace("₱", "")}
                      </span>
                    </div>
                  </div>
                  <span className="text-sm leading-6">
                    * This is the amount you need to pay if you make a motor
                    claim. It’s your share of the cost while your insurance
                    takes care of the claim.
                  </span>
                </div>

                {quoteData.batteryDeductible != null &&
                  quoteData.batteryDeductible !== "" && (
                    <div className="mt-3 bg-gray-50 p-3 rounded-lg">
                      <div className="flex">
                        <div className="flex-1 text-left">
                          <span className="text-left text-sm">
                            High Voltage Battery Deductible
                          </span>
                        </div>
                        <div className="flex-1 text-right">
                          <span className="text-sm">PHP</span>
                        </div>
                        <div className="flex-1 text-right">
                          <span className="text-sm">
                            {formatter
                              .format(quoteData.batteryDeductible)
                              .replace("₱", "")}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal open={open} setOpen={setOpen} title="Deductible">
        <div>
          <p>
            Is an amount of money that you yourself are responsible for paying
            toward an insured loss.
          </p>
        </div>
      </Modal>

      <button type="submit" className="hidden" id="btnSubmit">
        submit
      </button>
    </form>
  );
};

export default Quotation;
